import { MapCoordinate } from '@/features/orders/components/MapPanel/parts/Content/types'

export const toMapCoordinate = (
    coordinates?: { lat?: number | null; lng?: number | null } | null
): MapCoordinate | undefined => {
    if (!coordinates) return

    const { lat: latitude, lng: longitude } = coordinates

    if (
        typeof latitude !== 'number' ||
        typeof longitude !== 'number' ||
        !Number.isFinite(latitude) ||
        !Number.isFinite(longitude) ||
        Math.abs(latitude) > 90 ||
        Math.abs(longitude) > 180
    ) {
        return
    }

    return [longitude, latitude]
}
